import styled from 'styled-components';
import { scarpaGray600, spanishViridian25, spanishViridian500 } from '@habitech/shared';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  background-color: rgb(249 250 251);
  .date-picker {
    > div {
      border-radius: 6px;
    }
    input {
      padding: 11px 14px;
    }
  }
    .MuiInputBase-root {
      height: 47px;
      height: 47px;
      padding: 4px 10px 6px !important;
      svg {
        top: 2px;
        position: relative;
      }
    }
    .MuiInputBase-root:hover {
      background-color: ${spanishViridian25};
      cursor: pointer;
    }
    .MuiInputBase-root fieldset {
      border: 1px solid ${spanishViridian500} !important;
      border-radius: 6px;
    }
    .MuiInputBase-root fieldset:hover {
      border: none;
    }
    .Mui-focused fieldset {
      border: 2px solid ${spanishViridian500} !important;
      &.pcom-autocomplete {
        border: 2px solid ${spanishViridian500} !important;
        border-radius: 6px;
      }
    }
    input[type='number'] {
      text-align: center;
    }
`;

export const Title = styled.h1`
  font-size: 1.875rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #4c1d95;
`;

export const Section = styled.section`
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
`;

export const SectionTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #00843D;
  display: flex;
  align-items: center;
  
  svg {
    margin-right: 0.5rem;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 1.5rem;
  .calendar {
    width: 100%;
  }
`;

export const Label = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #4b5563;
  &.dates {
    margin-top: 24px;
  }
`;

export const ContainerSwitch = styled.div`
    display: grid;
    gap: 10px;
    margin-top: 24px;
`

export const Input = styled.input`
  width: 80%;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid #d1d5db;
  background-color: white;
  
  &:focus {
    outline: none;
    border-color: #00843D;
    box-shadow: 0 0 0 2px rgba(0, 132, 61, 0.2);
  }
`;

export const Textarea = styled.textarea`
  width: 96%;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid #d1d5db;
  background-color: white;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #00843D;
    box-shadow: 0 0 0 2px rgba(0, 132, 61, 0.2);
  }
`;

export const Radio = styled.input.attrs({ type: 'radio' })`
  margin-right: 0.5rem;
  accent-color: #00843D;
  
  &:checked {
    background-color: #00843D;
  }
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  margin-right: 0.5rem;
`;

export const RadioGroup = styled.div`
  display: flex;
`

export const RadioLabel = styled.label`
  display: inline-flex;
  align-items: center;
  margin-right: 1rem;
  font-size: 0.875rem;
  cursor: pointer;
  color: ${scarpaGray600};
`;

export const CheckboxLabel = styled.label`
  display: inline-flex;
  align-items: center;
  font-size: 0.875rem;
  cursor: pointer;
`;

export const Select = styled.select`
  width: 100%;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid #d1d5db;
  background-color: white;
  
  &:focus {
    outline: none;
    border-color: #8b5cf6;
    box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.2);
  }
`;

export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  font-weight: 500;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.15s ease;
  
  &.primary {
    background-color: #00843D;
    color: white;
    
    &:hover {
      background-color: #006B31;
    }
  }
  
  &.secondary {
    background-color: white;
    color: #4b5563;
    border: 1px solid #d1d5db;
    
    &:hover {
      background-color: #f9fafb;
    }
  }
  
  svg {
    margin-right: 0.5rem;
  }
`;

export const SQLTextArea = styled.textarea`
  width: 96%;
  min-height: 150px;
  padding: 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid #d1d5db;
  background-color: #f8f9fa;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;
  font-size: 0.875rem;
  line-height: 1.5;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #00843D;
    box-shadow: 0 0 0 2px rgba(0, 132, 61, 0.2);
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 1rem;
  
  @media (min-width: 640px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const FilterTag = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: #f3f4f6;
  border-radius: 9999px;
  padding: 0.25rem 0.75rem;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  
  button {
    background: none;
    border: none;
    cursor: pointer;
    margin-left: 0.5rem;
    display: flex;
    align-items: center;
    padding: 0;
  }
`;

export const RangeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  > div {
    width: 20%;
  }
  input[type='number'] {
    height: 30px;
    text-align: right;
  }
`;

export const RangeInput = styled.input`
  width: 100%;
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid #d1d5db;
  background-color: white;
  max-width: 100px;
  
  &:focus {
    outline: none;
    border-color: #00843D;
    box-shadow: 0 0 0 2px rgba(0, 132, 61, 0.2);
  }
`;



export const SwitchContainer = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
`;

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
`;

export const SwitchSlider = styled.span`
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
  background-color: #e0e0e0;
  border-radius: 34px;
  transition: all 0.3s ease;

  &::before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    border-radius: 50%;
    transition: all 0.3s ease;
  }

  ${SwitchInput}:checked + & {
    background-color: #00843D;
  }

  ${SwitchInput}:checked + &::before {
    transform: translateX(16px);
  }

  ${SwitchInput}:focus + & {
    box-shadow: 0 0 1px #00843D;
  }
`;

export const SwitchLabel = styled.span`
  font-size: 0.875rem;
  color: #222222;
`;
